import _ from 'lodash';
import React from 'react';
import { observer } from 'mobx-react-lite';

import useDispensaryProducts from 'src/dispensary/hooks/use-dispensary-products';
import usePaths from 'src/hooks/use-paths';

import { ProductCarousel } from 'src/components/carousel-v2/types/product-carousel';
import { defaultFilters } from '../carousels.utils';

const sortProducts = (fetched, products) =>
  _.sortBy(
    fetched,
    (a, b) =>
      _.findIndex(products, (product) => product === a?.id) - _.findIndex(products, (product) => product === b?.id)
  );

export const CustomCarousel = observer(({ section, showTitle = true, showLink = true }) => {
  const { label, products, id } = section;
  const { href } = usePaths({
    menuSection: {
      id,
    },
  });

  const { products: fetchedProducts, loading } = useDispensaryProducts({
    filters: { ...defaultFilters, productIds: products },
  });

  const hasProducts = fetchedProducts?.length > 0;
  if (!hasProducts && !loading) {
    return null;
  }

  const sortedProducts = sortProducts(fetchedProducts, products);

  return (
    <ProductCarousel
      products={sortedProducts}
      isLoading={loading}
      href={href}
      hideTitle={showTitle === false}
      hideLink={showLink === false}
      title={label}
    />
  );
});
